import { render } from "./StaffLayout.vue?vue&type=template&id=c9a49ba4&ts=true&lang=pug"
import script from "./StaffLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaffLayout.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__